<div class="page center">
  <div class="login-card">
    <div style="float: right;" class="eyebrow">VisitoCare</div>
    <div  style="margin-top:1cm; margin-bottom: 1cm;"> 
    <h2>Forgot password</h2>
  </div>
    <label>Email</label>
    <input [(ngModel)]="email" placeholder="Enter your email">

    <button (click)="send()" style="margin-top:20px;">Send reset link</button>

    <div style="float: right; margin-top:20px;">
      <div class="error" *ngIf="error">{{ error }}</div>
      <div class="small" *ngIf="message">{{ message }}</div>
    </div>
    <div class="small" style="margin-left:5px; margin-top: 20px;"><a class="link" routerLink="/login">Back to login</a></div>
    
    <!-- <div class="small" *ngIf="resetLink" style="margin-top:10px;">
      Reset link: <a class="link" [href]="resetLink">{{ resetLink }}</a>
    </div> -->
  </div>
</div>